import * as core from '@/application/filing-core';
import _ from 'lodash';
import cove from '@ctrack/cove';

export function getPartyFieldConfig ()
{
  return {
    requireAddress: false,
    requirePhone: false,
    requireEmail: false
  };
}

export function validateFilingCustomFieldsMap (bean)
{
  core.validateFilingCustomFieldsMap(bean);
  if (!_.isNil(bean.filing.customFieldsMap)) {
    if (bean.filing.customFieldsMap.classActionSuit && bean.filing.customFieldsMap.withinArbLimit === 1000364) {
      cove.validation.addError('filing.customFieldsMap.withinArbLimit', 'filing.customValidation.classActionMoneyDamages');
    }
  }
}